// Portal uploads are stored under a generated name (see `_safe_extension` in
// the patient-portal chat route), so the "filename" carries no information.
// Show the file type instead, matching what the patient sees in the portal.
const GENERATED_UPLOAD_NAME = /^[0-9a-f]{6,12}-\d{8}\.[a-z0-9]{1,8}$/i;

function extensionLabel(extension: string): string {
  return extension ? `${extension.toUpperCase()} document` : "Attachment";
}

/** Collapses generated upload names to their type, keeps real filenames. */
export function fileLabel(fileName: string): string {
  if (!GENERATED_UPLOAD_NAME.test(fileName)) return fileName;
  return extensionLabel(fileName.slice(fileName.lastIndexOf(".") + 1));
}

/** Type-only label for surfaces that never had a real filename to show. */
export function fileTypeLabel(url: string): string {
  try {
    // Signed URLs carry query params, so classify on the path only.
    const path = new URL(url).pathname;
    const dot = path.lastIndexOf(".");
    if (dot < path.lastIndexOf("/")) return "Attachment";
    return extensionLabel(path.slice(dot + 1).toLowerCase());
  } catch {
    return "Attachment";
  }
}
